<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
           <v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
              <v-layout wrap>
                <div class="flex md12">

                  <div v-show="codegorunum === true ">
                    <v-text-field :color="color" label="Masraf Merkezi Kodu" v-model="Masrafmerkezi.Code"
                      :error-messages="errors.collect('Masrafmerkezi.Code')" v-validate="'required|max:100'"
                      data-vv-name="Masrafmerkezi.Code" required></v-text-field>
                  </div>

                  <v-text-field :color="color" label="Masraf Merkezi Adı" v-model="Masrafmerkezi.CodeName"
                    :error-messages="errors.collect('Masrafmerkezi.CodeName')" v-validate="'required|max:100'"
                    data-vv-name="Masrafmerkezi.CodeName" required></v-text-field>
                </div>
              </v-layout>

            </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">GÜncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="deleteExpenceCenter()">Sİl</v-btn>
            </div>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">Vazgeç</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>Masraf Merkezi</v-toolbar-title>
        <v-spacer></v-spacer>
                           <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

        <v-btn flat @click="masrafmerkeziekle()"> Masraf Merkezİ Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>


    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
        <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.Code)" item>
            <td class="text-xs-left">{{ props.item.Code }}</td>
            <td class="text-xs-left">{{ props.item.CodeName }}</td>
            <td class="text-xs-left">{{ props.item.CompanyCode }}</td>
            <td class="text-xs-left">{{ props.item.Tip }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Masraf Merkezi Kodu',
            value: 'CompanyCode'
          },
          {
            text: 'Masraf Merkezi ',
            value: 'CodeName'
          },
          {
            text: 'Şirket Kodu',
            value: 'Code'
          },
          {
            text: 'Masraf Merkezi Tipi',
            value: 'Tip'
          }
        ],
        items: [],
        color: 'orange darken-4',
        selected: '',
        search3: '',
        m: false,
        k: false,
        dialog: false,
        Masrafmerkezi: {
          Code: '',
          CodeName: '',
          ExpenseCenterType: null,
          CompanyCode: ''
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
      }
    },
    mounted() {
      this.$validator.localize('tr', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Masraf Merkezi Güncelle'

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          Code: v
        }
        this.$http.post(auth.API_URL + 'api/ExpenseCenter/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Masrafmerkezi = response.body[0]
        })
      },
      deleteExpenceCenter: deleteExpenceCenter,
      masrafmerkeziekle: masrafmerkeziekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
  }

  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }

        this.Masrafmerkezi.CompanyCode = credentials.SirketKodu

        var params = this.Masrafmerkezi

        this.$http.post(auth.API_URL + 'api/ExpenseCenter/New', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }


  function masrafmerkeziekle() {
    this.$validator.reset()
    this.dialog = true
    this.Masrafmerkezi.Code = ''
    this.Masrafmerkezi.CodeName = ''
    this.dialog_baslik = 'Masraf Merkezi Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode: credentials.SirketKodu,
    }

    this.progress = true
    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
      }
    })
  }

  function deleteExpenceCenter() {
    if (window.confirm('Masraf Merkezin\'i silmek istediğinizden emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }
      this.Masrafmerkezi.CompanyCode = credentials.SirketKodu
      var params = this.Masrafmerkezi
      this.$http.post(auth.API_URL + 'api/ExpenseCenter/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text = 'Silme işlemi tamamlandı'
            this.snackbar = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu
        }

        this.Masrafmerkezi.CompanyCode = credentials.SirketKodu
        var params = this.Masrafmerkezi
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/ExpenseCenter/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = 'Güncelleme işlemi tamamlandı'
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>